export default "__VITE_ASSET__DdOOt7_o__"